// 9fbef606107a605d69c0edbcd8029e5d
export default {
  RECOMMENDATION: 'Stylistics_Recommendation',
  COMPLETETHELOOK: 'COMPLETE THE LOOK',
};
